import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["value"];
import React from "react";
import TextInput from "../TextInput";
import { format } from "./logic";
import { jsx as _jsx } from "react/jsx-runtime";
var DurationInput = /*#__PURE__*/React.forwardRef(function (_ref, forwardedRef) {
  var value = _ref.value,
    props = _objectWithoutProperties(_ref, _excluded);
  var formattedDuration = format(value);
  return /*#__PURE__*/_jsx(TextInput, _extends({
    value: value
  }, props, {
    type: "text",
    inputMode: "decimal",
    adornEnd: {
      type: "text",
      props: {
        text: formattedDuration
      }
    },
    ref: forwardedRef
  }));
});
DurationInput.displayName = "DurationInput";
export default DurationInput;